import { Brick, registerBrick, Query, Predicate, Order, BrickContext, ListDef } from 'olympe';

import Assessment from '../../../models/Assessment';
import InspectionEntity from '../../../models/InspectionEntity';
import Unit from '../../../models/Unit';

import AssessmentStatus from '../../../enums/AssessmentStatus';

/**
 * Assessments Filter
 * Get the whole list of assessments using filters
 * @extends Brick
 */
export default class AssessmentsFilter extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} country
     * @param {string} province
     * @param {string} region
     * @param {string} systemName
     * @param {AssessmentStatus.DRAFT | AssessmentStatus.FINAL} assessmentStatus
     * @param {boolean} isAdmin
     * @param {function(ListDef)} setFilteredList
     */
    async update($, [country, province, region, systemName, assessmentStatus, isAdmin], [setFilteredList]) {

        // Build the default predicate with country, province, and region
        let predicate = await Query.instancesOf(Assessment)
            .filter(Predicate.contains(Assessment.countryProp, country, false))
            .filter(Predicate.contains(Assessment.provinceProp, province, false))
            .filter(Predicate.contains(Assessment.regionProp, region, false));

        // If user is not admin, add predicate to exclude deleted assessments
        if (!isAdmin) {
            predicate = predicate.filter(Predicate.not(Predicate.equals(Assessment.deletedProp, true)));
        }

        // Ensure the assessment status is set of a valid value
        // -- If so, add the status predicate
        if(AssessmentStatus.isValid(assessmentStatus) && assessmentStatus !== AssessmentStatus.ALL) {
            predicate = predicate.filter(
                Predicate.equals(Assessment.draftProp, assessmentStatus === AssessmentStatus.DRAFT)
            );
        }

        predicate
            .sortBy(Assessment.lastModifiedProp, Order.DESC)
            .andReturn()
            .follow(Assessment.unitsRel)
            .follow(Unit.systemsRel)
            .filter(Predicate.contains(InspectionEntity.nameProp, systemName, false))
            .observe($)
            .subscribe((results) => {
                setFilteredList(results);
            });
    }
}

registerBrick('018ad5742b488d89f225', AssessmentsFilter);
